import Graduated from "@svg/new-design/graduated";
import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import classNames from "classnames";
import { FC } from "react";

interface Props {
  hugElement: boolean;
  productCount: number;
}
const CardProduct: FC<Props> = ({ hugElement, productCount }) => {
  const showProductCount = Boolean(productCount);

  if (!showProductCount) return null;
  return (
    <div
      className={classNames(
        showProductCount ? "flex" : "hidden md:flex",
        "gap-1 md:gap-1.5  text-fds-secondary"
      )}
    >
      {showProductCount ? (
        <Graduated className="text-fds-icon-secondary" />
      ) : null}
      <p className="text-fds-secondary body-xxsm md:body-xsm">
        {Boolean(showProductCount && productCount) ? (
          `${separateMoneyNumbers(toFarsiNumber(productCount))} دانشجو`
        ) : !hugElement ? (
          <br />
        ) : null}
      </p>
    </div>
  );
};

export default CardProduct;
